const atomic = require('../../../git_modules/@tomandco/atomic/config/color');

/**
 * Not all colors are used to generate atomic classes
 *
 * Use named colors in SCSS files by `get` function
 * @example
 * ```css
 *   .class {
 *     color: get('namedColor.abbey');
 *   }
 * ```
 */
const namedColor = {
    dune: '#211F1E', //1
    flint: '#6B6461', // 11
    zorba: '#9E9794', // 12
    alizarinCrimson: '#E8291C', // 2
    japaneseLaurel: '#008000', // 3
    alto: '#D9D9D9', // 5
    wildSand: '#F5F5F5', // 51
    sunglow: '#FECE34', // 6
    salomie: '#FFE180', // 61
    cork: '#47301F', // 62
    arrowtown: '#9B866D', // 63
    amazon: '#3D7E58', // 7
    sanJuan: '#2A5471', // 71
    gamboge: '#DAA510', // 72
    tuatara: '#353231', // 73
    codGray: '#0E0E0E', // 74
    nobel: '#B3B3B3' // 4
};
exports.namedColor = namedColor;

/**
 * Thouse colors are used to generate atomic classes.
 *
 * WARNING!!! `key` and `value` are required.
 * Other are used in iCMS
 *
 * @example
 * ```css
 *   .col-1 { color: #454647; }
 * ```
 */
const color = [
    { key: '1', value: namedColor.dune, title: 'Off black', group: 'Primary' },
    { key: '11', value: namedColor.flint, title: 'Dark grey', group: 'Primary' },
    { key: '12', value: namedColor.zorba, title: 'Light grey', group: 'Primary' },
    { key: '2', value: namedColor.alizarinCrimson, title: 'Error red', group: 'Status' },
    { key: '3', value: namedColor.japaneseLaurel, title: 'Success green', group: 'Status' },
    { key: '4', value: namedColor.nobel, title: 'Dark background', group: 'Backgrounds' },
    { key: '5', value: namedColor.alto, title: 'Background', group: 'Backgrounds' },
    { key: '51', value: namedColor.wildSand, title: 'Light background', group: 'Backgrounds' },
    { key: '6', value: namedColor.sunglow, title: 'Brand colour', group: 'Brand' },
    { key: '61', value: namedColor.salomie, title: 'Yellow tint', group: 'Brand' },
    { key: '62', value: namedColor.cork, title: 'Brown', group: 'Brand' },
    { key: '63', value: namedColor.arrowtown, title: 'Brown Tint', group: 'Brand' },
    { key: '7', value: namedColor.amazon, title: 'Cash Green', group: 'Account' },
    { key: '71', value: namedColor.sanJuan, title: 'Credit Blue', group: 'Account' },
    { key: '72', value: namedColor.gamboge, title: 'Credit Mustard', group: 'Account' },
    { key: '73', value: namedColor.tuatara, title: 'Accounts Dark Grey', group: 'Account' },
    { key: '74', value: namedColor.codGray, title: 'Accounts Black', group: 'Account' },
    { key: '8', value: 'black', title: 'Black', group: 'System' },
    { key: 'w', value: 'white', title: 'White', group: 'System' }
];
exports.color = color;
